module.exports = __webpack_public_path__ + "static/media/pod-action-alert.25efc78e.svg";